<template>
    <div class="quote__table" :class="{ loading: isLoading }">
        <template v-if="isLoading">
            <div
                id="loading-message"
                class="d-flex align-items-center justify-content-center flex-column"
            >
                <loadingSpinner />
                <h3 class="text-center">
                    {{ $t("promo.We’re assembling your quote") }}
                </h3>
            </div>
        </template>
        <template v-else>
            <div class="head justify-content-between d-none d-md-flex">
                <div class="left">
                    <div class="number">
                        {{ $t("promo.Quote") }} {{ quoteNumber }}
                    </div>
                    <div class="dates">
                        <div class="date-now">
                            {{ $t("promo.Date:") }} {{ today }}
                        </div>
                        <div class="date-valid-intil">
                            {{ $t("promo.Valid Until:") }} {{ validUntil }}
                        </div>
                    </div>
                </div>
                <div class="right text-right">
                    <div class="logo">
                        <img src="/images/promo/logo.svg" alt="" />
                    </div>
                    <div class="address" v-html="$t('promo.address')"></div>
                </div>
            </div>
            <table cellpadding="8" class="w-100 d-none d-md-table">
                <tbody>
                    <tr>
                        <td>#</td>
                        <td>{{ $t("promo.Description") }}</td>
                    </tr>
                    <tr>
                        <td class="pr-2"><b>{{ options.panels_number }}</b></td>
                        <td>
                            {{ moduleName }}
                            <!--            <info-tooltip :text="$t(`promo.Modules - tooltip - ${options.panel_type}`)"/>-->
                            <p
                                v-html="
                                    $t(
                                        `promo.Modules - info - ${options.panel_type}`
                                    )
                                "
                            ></p>
                        </td>
                    </tr>
                    <tr v-if="options.microinverters">
                        <td class="pr-2"><b>{{ options.panels_number }}</b></td>
                        <td>
                            {{ $t("promo.Microinverter") }}
                            <!--            <info-tooltip :text="$t('promo.Inverter - tooltip')"/>-->
                            <p>
                                {{ $t("promo.Microinverter - warranty") }}
                            </p>
                        </td>
                    </tr>
                    <tr v-else-if="options.power_optimizers">
                        <td class="pr-2"><b>{{ $t("promo.Inc") }}</b></td>
                        <td>
                            {{ $t("promo.Power Optimizers") }}
                            <!--            <info-tooltip :text="$t('promo.Inverter - tooltip')"/>-->
                            <p v-html="$t('promo.Power Optimizers - info')"></p>
                        </td>
                    </tr>
                    <tr v-else>
                        <td class="pr-2"><b>1</b></td>
                        <td>
                            {{ $t("promo.Inverter") }}
                            <!--            <info-tooltip :text="$t('promo.Inverter - tooltip')"/>-->
                            <p>
                                {{ $t("promo.Inverter - warranty") }}
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t("promo.Inc") }}</td>
                        <td>
                            {{ $t("promo.Mounting") }}
                            <!--            <info-tooltip :text="$t('promo.Mounting - tooltip')"/>-->
                            <p>
                                {{ $t("promo.Mounting - info") }}
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t("promo.Inc") }}</td>
                        <td>
                            {{ $t("promo.Labour") }}
                            <!--            <info-tooltip :text="$t('promo.Labour - tooltip')"/>-->
                            <p>
                                {{ $t("promo.Labour - info") }}
                            </p>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="quote__subtotal">
                <div class="line d-flex justify-content-between">
                    <div class="name">
                        {{ $t("promo.System price", {
                            value: installationSize
                        }) }}
                    </div>
                    <div class="price">{{ price | formatMoney }}</div>
                </div>
                <div class="line d-flex justify-content-between">
                    <div class="name">
                        {{ $t("promo.Online discount", {
                            value: discountPercentage
                        }) }}
                    </div>
                    <div class="price discount">
                        -{{ (price * discountPercentage * 0.01) | formatMoney }}
                    </div>
                </div>
            </div>
            <div class="quote__total">
                <div class="line d-flex justify-content-between">
                    <div class="name">
                        {{ $t("promo.Price after Discount") }}
                    </div>
                    <div class="price">
                        {{
                            (price * (1 - discountPercentage / 100))
                                | formatMoney
                        }}
                    </div>
                </div>
            </div>
            <div class="quote__subtotal" v-if="locale === 'pl'">
                <div class="line d-flex justify-content-between">
                    <div class="name">{{ $t("promo.Subsidy 1") }}</div>
                    <div class="price discount">-{{ 3000 | formatMoney }}</div>
                </div>
                <div class="line d-flex justify-content-between">
                    <div class="name">{{ $t("promo.Subsidy 2") }}</div>
                    <div class="price discount">
                        -{{
                            ((price * (1 - discountPercentage / 100) - 3000) *
                                0.17)
                                | formatMoney
                        }}
                    </div>
                </div>
            </div>

            <div class="quote__total" v-if="locale === 'pl'">
                <div class="line d-flex justify-content-between">
                    <div class="name">
                        {{ $t("promo.Price after Subsidies") }}
                    </div>
                    <div class="price">
                        {{
                            ((price * (1 - discountPercentage / 100) - 3000) *
                                0.83)
                                | formatMoney
                        }}
                    </div>
                </div>
                <div class="price-per-watt">
                    {{ $t("promo.Price Per Watt:") }}
                    <strong
                        >{{ pricePerWattPolishSubsidies }}
                        {{ currency }}</strong
                    >
                </div>
            </div>
            <div class="quote__disclaimer font-italic">
                {{ $t("promo.Quote Calculation disclaimer") }}
            </div>
        </template>
    </div>
</template>

<script>
import LoadingSpinner from "./LoadingSpinner";
import InfoTooltip from "./InfoTooltip";
import { mapGetters } from "vuex";

export default {
    data() {
        return {
            isLoading: true,
            discountPercentage: this.locale === "pl" ? 8 : 10,
        };
    },
    components: {
        LoadingSpinner,
        InfoTooltip,
    },
    computed: {
        pricePerWatt() {
            return (
                Math.round(
                    ((this.price * (1 - this.discountPercentage / 100)) /
                        (this.installationSize * 1000)) *
                        100
                ) / 100
            );
        },
        pricePerWattPolishSubsidies() {
            return (
                Math.round(
                    (((this.price * (1 - this.discountPercentage / 100) -
                        3000) *
                        0.83) /
                        (this.installationSize * 1000)) *
                        100
                ) / 100
            );
        },
        currency() {
            return process.env.MIX_APP_CURRENCY || "zł";
        },
        locale() {
            return process.env.MIX_APP_LOCALE || "pl";
        },
        moduleName() {
            if (this.options.panel_type === "glass-glass") {
                return this.$t("promo.glas-glass module name");
            } else {
                return this.$t("promo.glas-foil module name");
            }
        },
        today() {
            let d = new Date();
            return d.toLocaleDateString();
        },
        validUntil() {
            let d = new Date();
            d.setDate(d.getDate() + 14);
            return d.toLocaleDateString();
        },
        quoteNumber() {
            return `2021/21/${Math.round(Math.random() * 1000)}`;
        },
        ...mapGetters({
            price: "price",
            options: "options",
            installationSize: "installation_size",
        }),
    },
    mounted() {
        setTimeout(() => {
            this.isLoading = false;
        }, 2000);
    },
};
</script>

<style lang="scss" scoped>
#loading-message {
    h3 {
        font-style: normal;
        font-weight: 600;
        font-size: 28px;
        line-height: 54px;
        text-align: center;
        color: #ffffff;
        @media (max-width: 991px) {
            color: #141430;
        }
    }
}

.quote {
    &__disclaimer {
        font-weight: normal;
        font-size: 13px;
        line-height: 18px;
        color: rgba(20, 20, 48, 0.7);
        margin-top: 32px;
        @media (max-width: 768px) {
            display: none;
        }
    }

    &__total {
        border-top: 1px solid #cfd6ea;
        padding-top: 15px;

        @media (max-width: 991px) {
            padding-top: 8px;
        }

        .line {
            font-weight: bold;
            font-size: 22px;
            color: #141430;
        }

        .price-per-watt {
            font-weight: normal;
            font-size: 14px;

            color: #141430;
        }
    }

    &__subtotal {
        margin-top: 12px;
        margin-bottom: 12px;

        .line {
            font-size: 16px;
            color: #141430;
            padding-bottom: 4px;

            .discount {
                color: #00a842;
            }
        }
    }

    &__table {
        background: #ffffff;
        border-radius: 8px;
        padding: 42px 32px;
        width: 632px;
        max-width: calc(100% - 60px);

        &.loading {
            background: none;
        }

        @media (max-width: 991px) {
            padding: 8px 0 32px;
            max-width: initial;
            width: auto;
        }

        table {
            vertical-align: top;
            @media (max-width: 768px) {
                margin: 0px -15px;
                margin-bottom: 30px;
            }

            td {
                vertical-align: top;
                font-size: 14px;
                line-height: 20px;
                color: #1b2f51;

                &:first-child {
                    text-align: right;
                    @media (max-width: 768px) {
                        padding-left: 15px;
                    }
                }

                &:last-child {
                    @media (max-width: 768px) {
                        padding-right: 15px;
                    }
                }

                p {
                    font-size: 14px;
                    color: #959bb5;
                    margin: 0;
                }
            }

            tr:nth-child(2n) {
                background: #f7f9fc;
                vertical-align: top;
            }

            tr {
            }
        }

        .head {
            margin-bottom: 20px;

            .number {
                font-weight: bold;
                font-size: 28px;
                color: #141430;
            }

            .right {
                @media (max-width: 991px) {
                    display: none;
                }
            }

            .dates {
                font-style: normal;
                font-weight: normal;
                font-size: 14px;
                color: #959bb5;
            }

            .logo {
                padding-top: 8px;
                padding-bottom: 8px;

                img {
                    height: 24px;
                }
            }

            .address {
                font-size: 14px;
                color: #959bb5;
            }
        }
    }
}
</style>
